import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import { consolelog, delCancelToken } from '../../../../lib/tools';
import {
  createCancelToken,
  handleErrorResponse,
  handleErrorResponseType,
} from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

const createGroup = (apiToken, apiParams) => dispatch => {
  consolelog('[API CALL] createGroup()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_CREATE_GROUP;
  const { cancelToken, cancelTokenKey } = createCancelToken('createGroup');
  const axiosParams = { cancelToken, ...apiParams };

  return axios
    .post(url, axiosParams)
    .then(() => {
      dispatch({
        type: actionTypes.SUCCESS_API_CREATE_GROUP,
      });
    })
    .catch(thrown => {
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch, handleErrorResponseType.group);
      }
    })
    .finally(() => delCancelToken(cancelTokenKey));
};

export default createGroup;
